<script setup>
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'default',
  },
});

const classes = computed(() => {
  return [
    'tag',
    {
      [`tag--${props.type}`]: props.type !== 'default',
    },
  ];
});
</script>

<template>
  <span :class="classes">
    {{ value }}
  </span>
</template>
